import { render, staticRenderFns } from "./BchProductAdd.vue?vue&type=template&id=6dae834a&scoped=true"
import script from "./BchProductAdd.vue?vue&type=script&lang=js"
export * from "./BchProductAdd.vue?vue&type=script&lang=js"
import style0 from "./BchProductAdd.vue?vue&type=style&index=0&id=6dae834a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae834a",
  null
  
)

export default component.exports